import Badge from '@components/Badge/Badge.component'

import React from 'react'
import ParkingCard from '@components/ParkingCard/ParkingCard.component'

interface CardHeaderProps {
    text: string
    badgeText: string
    badgeVariant: 'positive' | 'warning' | 'negative' | 'information'
}

const CarpayOrderCardHeader = ({ text, badgeText, badgeVariant }: CardHeaderProps) => (
    <ParkingCard.Header>
        <ParkingCard.HeaderText>{text}</ParkingCard.HeaderText>
        <Badge text={badgeText} variant={badgeVariant} />
    </ParkingCard.Header>
)

export default CarpayOrderCardHeader
